import React from 'react'
import logo from '../img/logo.png'
import { Link } from 'react-router-dom' // npm i react-router-dom

const Navbar = () => {
  return (
    <nav class="navbar navbar-expand-lg pt-2 pb-2">
    <div class="container-fluid ms-5 me-5">
        <Link to='/'>
            <img src={logo} role="button" width="100px" alt="" />
        </Link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
        </button>
            <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
                <ul class="navbar-nav fs-5">
                    
                    <Link to='/' role="button" className="nav-link text-decoration-none" aria-current="page">Home
                    </Link>

                    <Link to='/players' role="button" className="nav-link text-decoration-none">Players
                    </Link>

                    <Link to='/standings' role="button" className="nav-link text-decoration-none">Standings
                    </Link>
                    
                    <Link to='/fixtures' role="button" className="nav-link text-decoration-none">Fixtures
                    </Link>
                   
                    <Link to='/stadium' role="button" className="nav-link text-decoration-none">Old Trafford
                    </Link>
                    
                </ul>
            </div>
    </div>
</nav>
  )
}

export default Navbar